import Vue from 'vue'
import extend from 'extend';
import Q from 'q';
import _ from 'underscore';
import moment from 'moment';
import QRCode from 'qrcode';
import get_uuid from 'nllib/src/common/get_uuid';
import {Loading} from 'element-ui';

import CountDown from '../count-down/index.vue';

import payment_notifyResult from '../../../../../../lib/data-service/payment/payment_notifyResult';

import payment_getPayChannel from '../../../../../../lib/data-service/payment/payment_getPayChannel';
import payment_paymentHandleTwo from '../../../../../../lib/data-service/payment/payment_paymentHandleTwo';

import call_ccb_pc_data_interface from '../../../../../../lib/common-service/yinzhilv/call_ccb_pc_data_interface';
import call_UnionPay_b2b_data_interface from '../../../../../../lib/common-service/yinzhilv/call_UnionPay_b2b_data_interface';
import call_UnionPay_b2c_data_interface from '../../../../../../lib/common-service/yinzhilv/call_UnionPay_b2c_data_interface';
import amount_rounded_to_cents from '../../../../../../../../src/common-service/amount_rounded_to_cents';

import icbc_jufutong_open_page from '../../../../../../lib/common-service/yinzhilv/icbc-jufutong/open_page';

if (!Vue.prototype._) {
    Vue.prototype._ = _;
}
global._ = _;
global.moment = moment;

const comment_function = function () {
    const paymentChannelList = [
        {
            "code": 6,
            "text": "授信",
        },
        {
            "code": 4,
            "text": "胤钱宝",
        },
        {
            "code": 3,
            "text": "个人网银",
        },
        {
            "code": 9,
            "text": "企业网银",
        },
        {
            "code": 10,
            "text": "个人信用卡网银",
        },
        {
            "code": 2,
            "text": "支付宝",
        },
        {
            "code": 1,
            "text": "微信",
        },
        {
            "code": 14,
            "text": "工行聚富通b2c",
        },
        {
            "code": 17,
            "text": "工行聚富通b2b",
        },
        {
            "code": 5,
            "text": "易宝支付",
        }
    ];
};

export default {
    components: {
        CountDown,
    },
    props: {
        situation: {
            type: String,
            default: `000`,
        },
    },
    data() {
        return {
            selected_payment_channel_code_for_select_mode_single_choice: -1,

            flag_selected_shouxin_zhifu_for_select_mode_multiple_choice: false,
            selected_payment_channel_code_for_select_mode_multiple_choice: [],

            data_web_common_pay_paymentChannel: {
                paymentChannels: [],
            },
            data_payment_paymentHandleTwo: {
                outTradeNo: ``,
            },
            data_check_function: {
                paymentStatus: -1,
            },

            paymentChannelEntityList: [],

            dialog_qrcode: {
                visible: false,
                //关闭场景：
                //000:由用户手动点击关闭按钮关闭
                //100:支付轮询时，支付成功关闭
                close_situation: `000`,//default|`close-by-p`
                title: `请打开支付宝扫码本二维码`,
                image_url: `https://yinzhilv-timed-task-bucket-alpha.oss-cn-shenzhen.aliyuncs.com/generate-tourism-product-data/alpha/P15459067/P15459067-qrcode.png`,
            },

            btn_pay: {
                id: `btn-pay-${get_uuid()}`,
                disabled: false,
                type: `primary`,
                text: `支付`,
            },

            loading: {
                instance: null,
                flag: false,
            },

            timer_to_check_payment_status: {
                id_setInterval: null,
            },

            situationParameter: {
                '000': {
                    companyId: -1,
                    clubId: -1,//中间社id
                    orderNo: ``,//订单编号
                    businessContent: ``,//不用管里面的值是什么，订单详情返回的businessContent,直接传入到这里
                    isUseCredit: 1,//是否允许授信支付
                    subject: ``,
                    orderAmount: 0,//订单金额，用于计算可以用哪些支付方式支付
                    count_down: {
                        enable: true,
                        pay_remaining_seconds: 0,//支付剩余时间，以秒为单位
                    },
                },
            },

            initLoading: true, // 初始化加载
        }
    },
    computed: {

        order_amount_text() {
            const __this = this;
            const orderAmount = __this.situationParameter[`000`].orderAmount;
            const r = amount_rounded_to_cents(orderAmount);
            return r;
        },

        payment_channel_entity_shouxin_zhifu() {
            const __this = this;
            const paymentChannelEntityList = __this.paymentChannelEntityList;

            let r = _.chain(paymentChannelEntityList)
                .find(function (m) {
                    return m.code === 6;
                })
                .value()
            ;
            if (!r) {
                r = {};
                r.code = -1;
                r.amount_number = 0;
            }
            return r;
        },

        payment_channel_entity_qianbao_zhifu() {
            const __this = this;
            const paymentChannelEntityList = __this.paymentChannelEntityList;

            let r = _.chain(paymentChannelEntityList)
                .find(function (m) {
                    return m.code === 4;
                })
                .value()
            ;
            if (!r) {
                r = {};
                r.code = -1;
                r.amount_number = 0;
            }
            return r;
        },

        select_mode() {
            const __this = this;

            const payment_channel_entity_shouxin_zhifu = __this.payment_channel_entity_shouxin_zhifu;
            const payment_channel_entity_qianbao_zhifu = __this.payment_channel_entity_qianbao_zhifu;

            //授信额度
            const amount_shouxin_zhifu = payment_channel_entity_shouxin_zhifu.amount_number;
            //钱包余额
            const amount_qianbao_zhifu = payment_channel_entity_qianbao_zhifu.amount_number;
            //订单金额
            const orderAmount = __this.situationParameter[`000`].orderAmount;

            let r;
            if (payment_channel_entity_shouxin_zhifu.code <= -1) {
                //没有返回授信支付，即该用户未开通授信支付
                //单选模式
                r = `single-choice`;
                return r;
            }

            if (amount_shouxin_zhifu >= orderAmount) {
                //授信额度 >= 订单金额
                //单选模式
                r = `single-choice`;
            } else {
                //授信额度 < 订单金额
                //多选模式
                r = `multiple-choice`;
            }
            return r;
        },

        selected_payment_channel_entity_code_list() {
            const __this = this;
            const select_mode = __this.select_mode;
            let r = [];
            if (select_mode === `single-choice`) {
                const selected_payment_channel_code_for_select_mode_single_choice = __this.selected_payment_channel_code_for_select_mode_single_choice;
                if (selected_payment_channel_code_for_select_mode_single_choice !== -1) {
                    r = [selected_payment_channel_code_for_select_mode_single_choice];
                }
            }
            if (select_mode === `multiple-choice`) {
                const flag_selected_shouxin_zhifu_for_select_mode_multiple_choice = __this.flag_selected_shouxin_zhifu_for_select_mode_multiple_choice;
                if (flag_selected_shouxin_zhifu_for_select_mode_multiple_choice) {
                    r.push(6);
                }
                const selected_payment_channel_code_for_select_mode_multiple_choice = __this.selected_payment_channel_code_for_select_mode_multiple_choice;
                r = r.concat(selected_payment_channel_code_for_select_mode_multiple_choice)
            }
            return r;
        },

        selected_payment_channel_entity_list() {
            const __this = this;
            const paymentChannelEntityList = __this.paymentChannelEntityList;
            const selected_payment_channel_entity_code_list = __this.selected_payment_channel_entity_code_list;
            const list = _.chain(paymentChannelEntityList)
                .filter(function (m) {
                    const code = m.code;
                    return _.contains(selected_payment_channel_entity_code_list, code);
                })
                .value()
            ;
            return list;
        },

        //非授权支付外的另一个支付方式
        selected_payment_channel_entity_exclude_shouxin_zhifu() {
            const __this = this;
            const selected_payment_channel_entity_list = __this.selected_payment_channel_entity_list;
            const r = _.chain(selected_payment_channel_entity_list)
                .find(function (m) {
                    return m.code !== 6;
                })
                .value()
            ;
            return r;
        },

    },
    watch: {
        selected_payment_channel_code_for_select_mode_single_choice(pNewValue, pOldValue) {
            const __this = this;
            __this.__init_payment_channel_entity_payment_amount();
            __this.__init_btn_pay_disable();
        },

        flag_selected_shouxin_zhifu_for_select_mode_multiple_choice(pNewValue, pOldValue) {
            const __this = this;
            __this.__init_payment_channel_entity_shouxin_zhifu_enable();
            __this.__init_payment_channel_entity_qianbao_zhifu_enable();
            __this.__init_payment_channel_entity_payment_amount();
            __this.__init_btn_pay_disable();
            __this.__clear_selected_value();
        },

        selected_payment_channel_code_for_select_mode_multiple_choice(pNewValue, pOldValue) {
            const __this = this;
            __this.__init_payment_channel_entity_shouxin_zhifu_enable();
            __this.__init_payment_channel_entity_qianbao_zhifu_enable();
            __this.__init_payment_channel_entity_payment_amount();
            __this.__init_btn_pay_disable();
        },
    },
    methods: {
        __init_payment_channel_entity_list() {
            const __this = this;

            return Q.when()
                .then(function (data) {
                    const companyId = __this.situationParameter[`000`].companyId;
                    const isUseCredit = __this.situationParameter[`000`].isUseCredit;
                    const orderAmount = __this.situationParameter[`000`].orderAmount;
                    const clientType = __this.situationParameter[`000`].clientType;
                    return payment_getPayChannel({
                        companyId: companyId,
                        isUseCredit: isUseCredit,
                        payAmount: orderAmount,
                        type: 1,
                        clientType: clientType,
                    });
                })
                .then(function (data) {
                    __this.data_web_common_pay_paymentChannel = data;

                    const paymentChannelEntityList = _.chain(__this.data_web_common_pay_paymentChannel.paymentChannels)
                        .map(function (m) {
                            const o = extend({}, m);
                            o.enable = true;
                            o.amount_string = m.amount;
                            o.amount_number = Number.parseFloat(o.amount_string);
                            o.payment_amount_string = `0.00`;
                            o.payment_amount_number = Number.parseFloat(o.payment_amount_string);
                            return o;
                        })
                        .value()
                    ;
                    // console.log(paymentChannelEntityList);
                    __this.paymentChannelEntityList = paymentChannelEntityList;
                })
                .catch(function (ex) {
                    console.error(ex);
                    if (ex) {
                        if (ex.stack) {
                            console.error(ex.stack);
                        }
                    }
                    return Q.reject(ex);
                })
                ;
        },

        __init_payment_channel_entity_shouxin_zhifu_enable() {
            const __this = this;
            const select_mode = __this.select_mode;

            const payment_channel_entity_shouxin_zhifu = __this.payment_channel_entity_shouxin_zhifu;
            const payment_channel_entity_qianbao_zhifu = __this.payment_channel_entity_qianbao_zhifu;

            //授信额度
            const amount_shouxin_zhifu = payment_channel_entity_shouxin_zhifu.amount_number;
            //钱包余额
            const amount_qianbao_zhifu = payment_channel_entity_qianbao_zhifu.amount_number;
            //订单金额
            const orderAmount = __this.situationParameter[`000`].orderAmount;

            if (amount_shouxin_zhifu <= 0) {
                payment_channel_entity_shouxin_zhifu.enable = false;
            } else {
                payment_channel_entity_shouxin_zhifu.enable = true;
            }

        },

        __init_payment_channel_entity_qianbao_zhifu_enable() {
            const __this = this;
            const select_mode = __this.select_mode;

            const payment_channel_entity_shouxin_zhifu = __this.payment_channel_entity_shouxin_zhifu;
            const payment_channel_entity_qianbao_zhifu = __this.payment_channel_entity_qianbao_zhifu;

            //授信额度
            const amount_shouxin_zhifu = payment_channel_entity_shouxin_zhifu.amount_number;
            //钱包余额
            const amount_qianbao_zhifu = payment_channel_entity_qianbao_zhifu.amount_number;
            //订单金额
            const orderAmount = __this.situationParameter[`000`].orderAmount;

            if (select_mode === `single-choice`) {
                //单选模式下，钱包支付是否可用，需要用钱包余额与订单金额相比较
                if (amount_qianbao_zhifu >= orderAmount) {
                    payment_channel_entity_qianbao_zhifu.enable = true;
                } else {
                    payment_channel_entity_qianbao_zhifu.enable = false;
                }
            }

            if (select_mode === `multiple-choice`) {
                //多选模式下
                const selected_payment_channel_entity_code_list = __this.selected_payment_channel_entity_code_list;
                if (_.contains(selected_payment_channel_entity_code_list, 6)) {
                    //如果选择了授信支付
                    //钱包支付是否可用，需要用钱包余额与差额相比较
                    const difference_amount = amount_rounded_to_cents(orderAmount - amount_shouxin_zhifu, {
                        return_type: `number`
                    });
                    if (amount_qianbao_zhifu >= difference_amount) {
                        payment_channel_entity_qianbao_zhifu.enable = true;
                    } else {
                        payment_channel_entity_qianbao_zhifu.enable = false;
                    }
                } else {
                    //如果没有选择授信支付
                    //钱包支付是否可用，需要用钱包余额与订单金额相比较
                    if (amount_qianbao_zhifu >= orderAmount) {
                        payment_channel_entity_qianbao_zhifu.enable = true;
                    } else {
                        payment_channel_entity_qianbao_zhifu.enable = false;
                    }
                }

            }
        },

        __init_payment_channel_entity_payment_amount() {
            const __this = this;

            const paymentChannelEntityList = __this.paymentChannelEntityList;
            const select_mode = __this.select_mode;
            const selected_payment_channel_entity_code_list = __this.selected_payment_channel_entity_code_list;
            const payment_channel_entity_shouxin_zhifu = __this.payment_channel_entity_shouxin_zhifu;
            const payment_channel_entity_qianbao_zhifu = __this.payment_channel_entity_qianbao_zhifu;

            //授信额度
            const amount_shouxin_zhifu = payment_channel_entity_shouxin_zhifu.amount_number;
            //钱包余额
            const amount_qianbao_zhifu = payment_channel_entity_qianbao_zhifu.amount_number;
            //订单金额
            const orderAmount = __this.situationParameter[`000`].orderAmount;

            _.each(paymentChannelEntityList, function (m) {
                m.payment_amount_string = `0.00`;
                m.payment_amount_number = Number.parseFloat(m.payment_amount_string);
            });

            if (select_mode === `single-choice`) {
                if (selected_payment_channel_entity_code_list.length === 1) {
                    const code = selected_payment_channel_entity_code_list[0];
                    const query = _.chain(paymentChannelEntityList)
                        .find(function (m) {
                            return m.code === code;
                        })
                        .value()
                    ;
                    if (!query) {
                        const msg = '__init_payment_channel_entity_payment_amount parameter error, code=001';
                        console.error(msg);
                        console.trace();
                        return;
                    }
                    query.payment_amount_number = parseFloat(orderAmount);
                    query.payment_amount_string = amount_rounded_to_cents(query.payment_amount_number);
                }
            }

            if (select_mode === `multiple-choice`) {
                if (selected_payment_channel_entity_code_list.length === 1) {
                    //如果只选中了一个
                    const code = selected_payment_channel_entity_code_list[0];
                    if (code === 6) {
                        //如果选中的是授信
                        //显示的金额等于授信额度
                        payment_channel_entity_shouxin_zhifu.payment_amount_number = amount_shouxin_zhifu;
                        payment_channel_entity_shouxin_zhifu.payment_amount_string = amount_rounded_to_cents(payment_channel_entity_shouxin_zhifu.payment_amount_number);
                    } else {
                        //如果选中的不是授信
                        //显示的金额等于订单金额
                        const query = _.chain(paymentChannelEntityList)
                            .find(function (m) {
                                return m.code === code;
                            })
                            .value()
                        ;
                        if (!query) {
                            return;
                        }
                        query.payment_amount_number = orderAmount;
                        query.payment_amount_string = amount_rounded_to_cents(query.payment_amount_number);
                    }

                }

                if (selected_payment_channel_entity_code_list.length === 2) {
                    //如果选中的有两个，即必有一个是授信支付

                    //授信支付显示的金额为授信额度
                    payment_channel_entity_shouxin_zhifu.payment_amount_number = amount_shouxin_zhifu;
                    payment_channel_entity_shouxin_zhifu.payment_amount_string = amount_rounded_to_cents(payment_channel_entity_shouxin_zhifu.payment_amount_number);

                    const code = _.chain(selected_payment_channel_entity_code_list)
                        .find(function (m) {
                            return m !== 6;
                        })
                        .value()
                    ;
                    if (code === undefined) {
                        const msg = '__init_payment_channel_entity_payment_amount parameter error, code=102';
                        console.error(msg);
                        console.trace();
                        return;
                    }
                    const query = _.chain(paymentChannelEntityList)
                        .find(function (m) {
                            return m.code === code;
                        })
                        .value()
                    ;
                    if (!query) {
                        return;
                    }

                    const difference_amount = amount_rounded_to_cents(orderAmount - amount_shouxin_zhifu, {
                        return_type: `number`
                    });

                    //除授信支付外的另一个支付方式的金额，显示的是差额
                    query.payment_amount_number = difference_amount;
                    query.payment_amount_string = amount_rounded_to_cents(query.payment_amount_number);

                }
            }
        },

        __clear_selected_value() {
            const __this = this;
            const select_mode = __this.select_mode;
            const selected_payment_channel_entity_code_list = __this.selected_payment_channel_entity_code_list;
            const payment_channel_entity_qianbao_zhifu = __this.payment_channel_entity_qianbao_zhifu;

            if (select_mode === `multiple-choice`) {
                //如果当前是多选模式
                if (selected_payment_channel_entity_code_list.length === 1) {
                    //如果当前只选择了一个
                    const code = selected_payment_channel_entity_code_list[0];
                    if (code === 4) {
                        //如果选择的是钱包支付

                        //钱包余额
                        const amount_qianbao_zhifu = payment_channel_entity_qianbao_zhifu.amount_number;
                        //订单金额
                        const orderAmount = __this.situationParameter[`000`].orderAmount;

                        if (amount_qianbao_zhifu < orderAmount) {
                            //如果钱包余额 < 订单金额
                            //清空选中的所有支付方式
                            __this.flag_selected_shouxin_zhifu_for_select_mode_multiple_choice = false;
                            __this.selected_payment_channel_code_for_select_mode_multiple_choice = -1;
                        }
                    }
                }
            }
        },

        __init_btn_pay_disable() {
            const __this = this;
            const selected_payment_channel_entity_list = __this.selected_payment_channel_entity_list;
            const orderAmount = __this.situationParameter[`000`].orderAmount;

            __this.btn_pay.disabled = false;

            if (selected_payment_channel_entity_list.length <= 0) {
                __this.btn_pay.disabled = true;
                return;
            }

            let sum_amount = 0;
            _.each(selected_payment_channel_entity_list, function (m) {
                sum_amount += m.payment_amount_number;
            });
            sum_amount = parseFloat(sum_amount.toFixed(2));
            if (sum_amount < orderAmount) {
                __this.btn_pay.disabled = true;
                return;
            }
        },

        __start_timer_to_check_payment_status(pParameter) {
            const __this = this;

            if (!pParameter) pParameter = {};
            const tradeNo = pParameter.tradeNo;
            if (!tradeNo) {
                const msg = '__start_timer_to_check_payment_status parameter error, code=001';
                console.error(msg);
                return Q.reject({msg: msg});
            }

            const check_function = payment_notifyResult;
            const paymentStatus_success = 2;
            const paymentStatus_failure = 3;
            // 支付状态：0：已失效 1：支付中 2：已支付 3：支付失败

            __this.__stop_timer_to_check_payment_status();
            __this.timer_to_check_payment_status.id_setInterval = setInterval(function () {
                Q.when()
                    .then(function () {
                        return check_function({
                            tradeNo,
                        });
                    })
                    .then(function (data) {
                        __this.data_check_function = data;
                        const paymentStatus = data.paymentStatus;
                        if (_.contains([paymentStatus_success, paymentStatus_failure], paymentStatus)) {
                            //paymentStatus
                            //支付状态：0：待支付 1：支付中 2：已支付 3：支付失败
                            __this.__stop_timer_to_check_payment_status();
                            __this.__close_loading();

                            if (paymentStatus === paymentStatus_success) {
                                __this.dialog_qrcode.close_situation = `100`;
                                __this.dialog_qrcode.visible = false;

                                let payment_channel_entity = __this.selected_payment_channel_entity_exclude_shouxin_zhifu;
                                if (!payment_channel_entity) {
                                    //找不到非授权支付的另一个支付方式
                                    //即单选模式，并且只选择了授信支付
                                    __this.btn_pay.disabled = true;
                                    __this.btn_pay.type = `success`;
                                    __this.btn_pay.text = `支付成功`;

                                    const pay_successful_event_handler = __this.pay_successful_event_handler;
                                    if (_.isFunction(pay_successful_event_handler)) {
                                        pay_successful_event_handler();
                                        return;
                                    }
                                    return;
                                }

                                if (payment_channel_entity.code === 4) {
                                    //钱包支付
                                    __this.btn_pay.disabled = true;
                                    __this.btn_pay.type = `success`;
                                    __this.btn_pay.text = `支付成功`;
                                }

                                if (payment_channel_entity.code === 2) {
                                    //支付宝支付
                                    __this.btn_pay.disabled = true;
                                    __this.btn_pay.type = `success`;
                                    __this.btn_pay.text = `支付成功`;
                                }

                                if (payment_channel_entity.code === 1) {
                                    //微信支付
                                    __this.btn_pay.disabled = true;
                                    __this.btn_pay.type = `success`;
                                    __this.btn_pay.text = `支付成功`;
                                }

                                if (payment_channel_entity.code === 3) {
                                    //网银
                                }

                                if (payment_channel_entity.code === 5) {
                                    //易宝支付
                                }

                                __this.__init_can_choose_payment_channel({
                                    flag: false,
                                });

                                const pay_successful_event_handler = __this.pay_successful_event_handler;
                                if (_.isFunction(pay_successful_event_handler)) {
                                    pay_successful_event_handler();
                                    return;
                                }

                            }

                            if (paymentStatus === paymentStatus_failure) {

                                const pay_failed_event_handler = __this.pay_failed_event_handler;
                                if (_.isFunction(pay_failed_event_handler)) {
                                    pay_failed_event_handler();
                                    return;
                                }
                                alert(`支付失败！`);
                            }

                        }
                    })
                    .catch(function (ex) {
                        console.error(ex);
                        if (ex) {
                            if (ex.stack) {
                                console.error(ex.stack);
                            }
                        }
                        return Q.reject(ex);
                    })
                ;
            }, 2 * 1000);

        },

        __stop_timer_to_check_payment_status() {
            const __this = this;
            clearInterval(__this.timer_to_check_payment_status.id_setInterval);
            __this.data_check_function.paymentStatus = -1;
        },

        __close_loading() {
            const __this = this;
            __this.loading.flag = false;

            if (!__this.loading.instance) return;
            __this.loading.instance.close();
        },

        __init_can_choose_payment_channel({flag}) {
            const __this = this;
            const paymentChannelEntityList = __this.paymentChannelEntityList;
            _.each(paymentChannelEntityList, function (m) {
                m.enable = flag;
            });
        },

        __btn_pay_click() {
            const __this = this;
            __this.btn_pay.disabled = true;

            const paymentChannelEntityList = __this.paymentChannelEntityList;
            const selected_payment_channel_entity_code_list = __this.selected_payment_channel_entity_code_list;
            const selected_payment_channel_entity_list = __this.selected_payment_channel_entity_list;
            // console.log(`__this.selected_payment_channel_code_for_select_mode_single_choice=${__this.selected_payment_channel_code_for_select_mode_single_choice}`);
            // console.log(`__this.flag_selected_shouxin_zhifu_for_select_mode_multiple_choice=${__this.flag_selected_shouxin_zhifu_for_select_mode_multiple_choice}`);
            // console.log(`__this.selected_payment_channel_code_for_select_mode_multiple_choice=${__this.selected_payment_channel_code_for_select_mode_multiple_choice}`);
            // console.log(selected_payment_channel_entity_list);
            // return;

            if (selected_payment_channel_entity_code_list.length <= 0) {
                alert(`请选择支付方式！`);
                __this.btn_pay.disabled = false;
                return;
            }

            const before_pay_event_handler = __this.before_pay_event_handler;
            let promise_before_pay_event_handler = Q.when();
            if (_.isFunction(before_pay_event_handler)) {
                promise_before_pay_event_handler = promise_before_pay_event_handler
                    .then(function () {
                        return before_pay_event_handler();
                    })
                ;
            }

            return Q.when()
                .then(function () {
                    return promise_before_pay_event_handler;
                })
                .then(function () {
                    const list = _.chain(selected_payment_channel_entity_list)
                        .filter(function (m) {
                            //授信支付（6）、钱钱支付（4）需要输入支付密码
                            return 1 === 1
                                && _.contains([6, 4], m.code)
                                ;
                        })
                        .value()
                    ;

                    if (list.length > 0) {
                        //钱包支付
                        return __this.$prompt('', '请输入支付密码', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            inputType: 'password',
                            inputValidator(pValue) {
                                const flag = !!pValue;
                                return flag;
                            },
                            inputErrorMessage: `请输入支付密码！`,
                        });
                    }

                    return Q.resolve({
                        value: ``,
                    });
                })
                .then(function (data) {
                    const password = data.value;

                    const list = _.chain(selected_payment_channel_entity_list)
                        .map(function (m) {
                            const payment_amount_number = m.payment_amount_number;
                            const code = m.code;
                            const o = {};
                            o.amount = payment_amount_number;
                            o.paymentChannel = code;
                            return o;
                        })
                        .value()
                    ;
                    // console.log(list);

                    __this.loading.instance = Loading.service({
                        // target: `#${__this.btn_pay.id}`,
                    });
                    __this.loading.flag = true;

                    const companyId = __this.situationParameter[`000`].companyId;
                    const clubId = __this.situationParameter[`000`].clubId;
                    const orderNo = __this.situationParameter[`000`].orderNo;
                    const businessContent = __this.situationParameter[`000`].businessContent;
                    const subject = __this.situationParameter[`000`].subject;
                    const clientType = __this.situationParameter[`000`].clientType;
                    const paymentChannelVos = list;

                    if (
                        _.contains(selected_payment_channel_entity_code_list, 3)
                        || _.contains(selected_payment_channel_entity_code_list, 9)
                        || _.contains(selected_payment_channel_entity_code_list, 10)
                        || _.contains(selected_payment_channel_entity_code_list, 7)
                        || _.contains(selected_payment_channel_entity_code_list, 8)
                        || _.contains(selected_payment_channel_entity_code_list, 5)
                        || _.contains(selected_payment_channel_entity_code_list, 14)
                        || _.contains(selected_payment_channel_entity_code_list, 17)
                    ) {
                        //如果选择的支付方式，包含网银、企业银联、个人银联、工行聚富通b2c、工行聚富通b2b、易宝，
                        //即打开第三方支付界面的支付方式，
                        //打开第三方支付界面后，
                        //仍然可以在当前页面重新支付，
                        //仍然可以在当前页面选择支付方式
                        __this.__init_can_choose_payment_channel({
                            flag: true,
                        });
                        __this.__init_payment_channel_entity_shouxin_zhifu_enable();
                        __this.__init_payment_channel_entity_qianbao_zhifu_enable();
                    } else {
                        __this.__init_can_choose_payment_channel({
                            flag: false,
                        });
                        __this.__init_payment_channel_entity_shouxin_zhifu_enable();
                        __this.__init_payment_channel_entity_qianbao_zhifu_enable();
                    }

                    const p = {
                        companyId: companyId,
                        clubId: clubId,
                        orderNo: orderNo,
                        businessContent: businessContent,
                        subject: subject,
                        paymentChannelVos: paymentChannelVos,
                        password: password,
                        clientType: clientType,
                    };
                    return payment_paymentHandleTwo(p);
                })
                .then(function (data) {
                    __this.data_payment_paymentHandleTwo = data;

                    //获取非授权支付外的另一个支付方式
                    const payment_channel_entity = __this.selected_payment_channel_entity_exclude_shouxin_zhifu;

                    if (!payment_channel_entity) {
                        //找不到非授权支付的另一个支付方式
                        //即单选模式，并且只选择了授信支付
                        return Q.resolve();
                    }

                    if (payment_channel_entity.code === 4) {
                        //钱包支付
                        return Q.resolve();
                    }

                    if (payment_channel_entity.code === 2) {
                        //支付宝支付
                        const resultMap = data.resultMap;
                        const ALIPAY = resultMap.ALIPAY;
                        return QRCode.toDataURL(ALIPAY).then(function (url) {
                            __this.dialog_qrcode.title = `请打开支付宝扫码本二维码`;
                            __this.dialog_qrcode.image_url = url;
                            __this.dialog_qrcode.close_situation = `000`;
                            __this.dialog_qrcode.visible = true;
                        });
                    }

                    if (payment_channel_entity.code === 1) {
                        //微信支付
                        const resultMap = data.resultMap;
                        const WECHAT = resultMap.WECHAT;
                        return QRCode.toDataURL(WECHAT).then(function (url) {
                            __this.dialog_qrcode.title = `请打开微信扫码本二维码`;
                            __this.dialog_qrcode.image_url = url;
                            __this.dialog_qrcode.close_situation = `000`;
                            __this.dialog_qrcode.visible = true;
                        });
                    }

                    if (_.contains([3, 9, 10], payment_channel_entity.code)) {
                        //3.个人网银
                        //9.企业网银
                        //10.个人信用卡网银
                        const resultMap = data.resultMap;
                        const BODY = resultMap.BODY;
                        const CONTENTTYPE = resultMap.CONTENTTYPE;
                        const INFO = resultMap.INFO;
                        const SIGN = resultMap.SIGN;
                        return call_ccb_pc_data_interface({
                            BODY,
                            CONTENTTYPE,
                            INFO,
                            SIGN,
                        }).then(function () {
                            __this.__close_loading();
                        });
                    }

                    if (payment_channel_entity.code === 7) {
                        //企业银联
                        const resultMap = data.resultMap;
                        return call_UnionPay_b2b_data_interface(resultMap).then(function () {
                            __this.__close_loading();
                        });
                    }

                    if (payment_channel_entity.code === 8) {
                        //个人银联
                        const resultMap = data.resultMap;
                        return call_UnionPay_b2c_data_interface(resultMap).then(function () {
                            __this.__close_loading();
                        });
                    }

                    if (payment_channel_entity.code === 14) {
                        //工行聚富通b2c
                        const htmlStr = data.htmlStr;
                        icbc_jufutong_open_page({
                            htmlStr,
                        });
                        __this.__close_loading();
                        return Q.resolve();
                    }

                    if (payment_channel_entity.code === 17) {
                        //工行聚富通b2b
                        const htmlStr = data.htmlStr;
                        const url_001 = `yinzhilv-open-ie:${htmlStr}`;
                        const url_002 = url_001.replace(/&/gi, `yinzhilv-open-ie-separator`);//一定要将&替换成yinzhilv-open-ie-separator，否则参数会丢失
                        global.open(url_002);
                        __this.__close_loading();
                        return Q.resolve();
                    }

                    if (payment_channel_entity.code === 5) {
                        //易宝支付
                        const htmlStr = data.htmlStr;
                        global.open(htmlStr);
                        __this.__close_loading();
                        return Q.resolve();
                    }

                })
                .then(function () {
                    __this.btn_pay.disabled = false;
                    const paymentOrder = __this.data_payment_paymentHandleTwo.outTradeNo;//永远用toPay返回的那个outTradeNo
                    __this.__start_timer_to_check_payment_status({
                        tradeNo: paymentOrder,
                    });
                })
                .catch(function (ex) {
                    __this.btn_pay.disabled = false;
                    __this.__init_can_choose_payment_channel({flag: true});
                    __this.__init_payment_channel_entity_shouxin_zhifu_enable();
                    __this.__init_payment_channel_entity_qianbao_zhifu_enable();
                    __this.__close_loading();
                    console.error(ex);
                    if (ex) {
                        if (ex.stack) {
                            console.error(ex.stack);
                        }
                    }
                    // return Q.reject(ex);
                })
                ;
        },

        __btn_payment_channel_entity_row_click(p_payment_channel_entity) {
            const __this = this;

            const payment_channel_entity = p_payment_channel_entity;
            const enable = payment_channel_entity.enable;
            const code = payment_channel_entity.code;

            const select_mode = __this.select_mode;

            if (select_mode === `single-choice`) {
                if (enable) {
                    __this.selected_payment_channel_code_for_select_mode_single_choice = code;
                }
            }

            if (select_mode === `multiple-choice`) {
                if (enable) {
                    if (code === 6) {
                        //授信支付
                        __this.flag_selected_shouxin_zhifu_for_select_mode_multiple_choice = !__this.flag_selected_shouxin_zhifu_for_select_mode_multiple_choice;
                    }
                    if (code !== 6) {
                        __this.selected_payment_channel_code_for_select_mode_multiple_choice = code;
                    }
                }
            }
        },

        __set_payment_channel_disabled(pEntity) {
            const __this = this;
            // if (__this.loading.flag) {
            //   return true;
            // }
            if (!pEntity.enable) {
                return true;
            }
            // if (__this.data_check_function.paymentStatus !== -1) {
            //   return true;
            // }
            return false;
        },

        __dialog_qrcode_closed_event_handler() {
            const __this = this;
            __this.__close_loading();
            __this.__stop_timer_to_check_payment_status();

            if (__this.dialog_qrcode.close_situation === `000`) {
                //如果是：由用户手动点击关闭按钮关闭
                //允许选择支付方式
                __this.__init_can_choose_payment_channel({flag: true});
            }

            if (__this.dialog_qrcode.close_situation === `100`) {
                //如果是：支付轮询时，支付成功关闭
                //不允许选择支付方式
                __this.__init_can_choose_payment_channel({flag: false});
            }

        },

        __show_count_down() {
            const __this = this;
            if (!__this.situationParameter[`000`].count_down.enable) return false;
            // if (__this.data_check_function.paymentStatus !== -1) return false;
            return true;
        },

        init(pParameter) {
            const __this = this;

            const defaultParameter = {};
            defaultParameter.situationParameter = {};

            defaultParameter.situationParameter[`000`] = {};
            defaultParameter.situationParameter[`000`].companyId = -1;
            defaultParameter.situationParameter[`000`].clubId = -1;
            defaultParameter.situationParameter[`000`].orderNo = ``;
            defaultParameter.situationParameter[`000`].businessContent = ``;
            defaultParameter.situationParameter[`000`].isUseCredit = 1;
            defaultParameter.situationParameter[`000`].subject = ``;
            defaultParameter.situationParameter[`000`].orderAmount = 0;
            defaultParameter.situationParameter[`000`].clientType = 1;
            defaultParameter.situationParameter[`000`].count_down = {};
            defaultParameter.situationParameter[`000`].count_down.enable = false;
            defaultParameter.situationParameter[`000`].count_down.pay_remaining_seconds = 0;

            defaultParameter.btn_pay = {};
            defaultParameter.btn_pay.text = `支付`;

            const parameter = extend(true, {}, defaultParameter, pParameter);
            if (parameter.situationParameter[`000`].count_down.pay_remaining_seconds <= 0) {
                parameter.situationParameter[`000`].count_down.pay_remaining_seconds = 60;
            }

            __this.situationParameter = parameter.situationParameter;
            __this.before_pay_event_handler = parameter.before_pay_event_handler;
            __this.pay_successful_event_handler = parameter.pay_successful_event_handler;
            __this.pay_failed_event_handler = parameter.pay_failed_event_handler;

            __this.btn_pay.text = parameter.btn_pay.text;

            Q.when()
                .then(function () {
                    __this.initLoading = true
                    __this.__stop_timer_to_check_payment_status();
                    return __this.__init_payment_channel_entity_list();
                })
                .then(function (data) {
                    __this.__init_payment_channel_entity_shouxin_zhifu_enable();
                    __this.__init_payment_channel_entity_qianbao_zhifu_enable();
                    __this.__init_payment_channel_entity_payment_amount();
                    __this.initLoading = false
                    if (__this.situationParameter[`000`].count_down.enable) {
                        __this.$refs.aCountDown.init({
                            seconds: __this.situationParameter['000'].count_down.pay_remaining_seconds,
                            time_is_running_out_event_handler: function () {
                                __this.btn_pay.disabled = true;
                                __this.btn_pay.type = `danger`;
                                __this.btn_pay.text = `支付超时`;
                            },
                        });
                    }

                })
                .catch(function (ex) {
                    __this.initLoading = false
                    console.error(ex);
                    if (ex) {
                        if (ex.stack) {
                            console.error(ex.stack);
                        }
                    }
                    return Q.reject(ex);
                })
            ;
        },
    },
    mounted() {
        const __this = this;
    },
}
